(function () {
    'use strict';

    angular
        .module('app')
        .controller('CommunicationSettingEditCtrl', CommunicationSettingEditCtrl);

    /**
     * @ngdoc controller
     * @name CommunicationSettingEditCtrl
     *
     * @description
     * Edit screen for communication setting.
     */

    CommunicationSettingEditCtrl.$inject = [
        '$scope',
        '$q',
        'SystemService',
        'NavigationAidService',
        'DialogService',
        'LastUpdatedService',
        'UnsavedChangesService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService'];

    function CommunicationSettingEditCtrl(
        $scope,
        $q,
        SystemService,
        NavigationAidService,
        DialogService,
        LastUpdatedService,
        UnsavedChangesService,
        ObjectSaveErrorHandlerService,
        WindowTitleService) {

        /* jshint validthis:true */
        var vm = this;
        vm.communicationSetting = {};
        vm.saveCommunicationSetting = saveCommunicationSetting;
        vm.close = close;
        vm.loading = true;
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'lastUpdatedLabel', { get: function () { return LastUpdatedService.getLabel(vm.communicationSetting); } });
        vm.locales = [
            { Name: 'Australia', Code: 'AU' },
            { Name: 'Canada', Code: 'CA' },
            { Name: 'Ireland', Code: 'IE' },
            { Name: 'New Zealand', Code: 'NZ' },
            { Name: 'South Africa', Code: 'ZA' },
            { Name: 'United Kingdom', Code: 'GB' },
            { Name: 'United States', Code: 'US' }
        ];

        activate();
        
        function activate() {
            WindowTitleService.setTitle('Communication Settings');

            var loadPromises = [];
            loadPromises.push(loadCommunicationSetting());

            $q.all(loadPromises)
                .then(function () {
                    vm.loading = false;
                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.communicationSetting',
                        saveFunction: saveCommunicationSetting,
                        unsavedItemName: 'Communication Setting'
                    });
                });
        }

        /**
         * Load the communication setting to the viewmodel
         *
         * @returns {promise} A promise that resolves once the communication setting is loaded.
         */
        function loadCommunicationSetting() {
            return SystemService.getCommunicationSetting()
                .then(getCommunicationSettingOk, getCommunicationSettingError);

            function getCommunicationSettingOk(data) {
                vm.communicationSetting = data;
            }

            function getCommunicationSettingError(response) {
                vm.error = 'Error fetching communication setting';
            }
        }

        /**
         * Is a string alphanumeric?
         *
         * @returns True if a string is alphanumeric.
         */
        function isAlphaNumeric(str) {
            return str.match(/^[a-z0-9]+$/i) !== null;
        }

        /**
         * Save the communication setting and navigate away from the system setting edit page.
         *
         * @returns {promise} A promise that resolves once the communication setting has been saved.
         */
        function saveCommunicationSetting() {
            var promise = null;

            if (!_.isNil(vm.addCommunicationSettingForm) && vm.addCommunicationSettingForm.$invalid) {
                promise = DialogService.messageList('Error saving communication setting', null, vm.addCommunicationSettingForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else if (!isAlphaNumeric(vm.communicationSetting.SenderId)) {
                promise = DialogService.messageList('Error saving communication setting', ['Sender ID can only contain alphanumeric characters'], vm.addCommunicationSettingForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else {
                var communicationSetting = angular.copy(vm.communicationSetting);

                promise = SystemService.saveCommunicationSetting(communicationSetting)
                    .then(saveCommunicationSettingOk, saveCommunicationSettingError);
            }

            return promise;

            function saveCommunicationSettingOk(response) {
                vm.communicationSetting = response;
                vm.addCommunicationSettingForm.$setPristine();

                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.communicationSetting',
                    saveFunction: saveCommunicationSetting,
                    unsavedItemName: 'Communication Setting'
                });
            }

            function saveCommunicationSettingError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.communicationSetting,
                    'Communication Setting',
                    vm.saveCommunicationSetting,
                    function () {
                        return SystemService.getCommunicationSetting();
                    });
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();
